import React, { Component } from "react";

import "../CSS/style_ExplanationPortal.css";
import "../CSS/style_Home.css";

import { LABEL_PAGE_Company, LABEL_PAGE_Libra, LABEL_PAGE_CustomPrints, LABEL_PAGE_CustomPrintsA, LABEL_PAGE_Printer, LABEL_PAGE_CustomTables, LABEL_PAGE_CustomTablesA,
         LABEL_PAGE_CustomFields,LABEL_PAGE_CustomFieldsA, LABEL_PAGE_Librasm, LABEL_PAGE_Weigh, LABEL_Plant, LABEL_PAGE_Operators, LABEL_PAGE_Settings, LABEL_PAGE_Holding, LABEL_Logout,
         LABEL_Choose_Plant,LABEL_PAGE_Libras, LABEL_Payment, LABEL_PAGE_UpgradePro, LABEL_PAGE_UpgradeCloud } from "../Utils/Strings/Labels";
         
export default class ExplanationPortal extends Component {

  render() {

    const styles = {
      i: {
        background: "white",
        fontSize : "45px"
      }
    };

    var USERLANGUAGE = this.props.Language;

    return(
        <div className="ex-p-container clearfix">
            <div className="left ex-p-nav">
                <div className="home-menu"> 
                    <div className="icon-menu">
                        <ul>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-receipt icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Weigh[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Libras[USERLANGUAGE]}</div>
                            </li>
                            
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_Plant[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Company[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_CustomFieldsA[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_CustomTablesA[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Operators[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Holding[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_PAGE_Settings[USERLANGUAGE]}</div>
                            </li>
                            <li  onClick={() => { console.log("simone") }}>
                                <i className="icon-balance-scale icone-home" style={styles.i}/>
                                <div className="icon-label">{LABEL_Payment[USERLANGUAGE]}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="rigth ex-p-page">
                
            </div>

        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_ExplanationPortal.js